import { DateFormat, PuxText, useTranslation } from "@phonero/pux-react"
import { InfoBox } from "../Other/InfoBox"
import css from "./ActiveSimCardDetails.module.scss"
import classNames from "classnames"
import { useBreakpointDesktop } from "../util"
import { FC } from "react"
import { Maybe } from "@phonero/common-graphql/types"
import { Price } from "../Other"

interface IActiveSimCardDetailsProps {
  mode?: string
  style?: any
  lastUsed?: Maybe<string | Date>
  usage: number
  activationDate?: Maybe<string | Date>
  deviceName: Maybe<string | undefined>
  price: Maybe<number>
  showPrice: boolean
}

export const ActiveSimCardDetails: FC<IActiveSimCardDetailsProps> = ({
  mode,
  style,
  lastUsed,
  usage,
  activationDate,
  deviceName,
  price,
  showPrice,
}) => {
  const { i18n } = useTranslation()
  const isDesktop = useBreakpointDesktop()
  return (
    <div
      className={classNames(
        css.simDetailsTextArea,
        mode === "light" ? css.light : css.dark
      )}
      style={style}
    >
      {/* Removing last used date if usage is above 0 and there is no last used date. Has been an error so just in case... */}
      {!(usage > 0 && !lastUsed) && (
        <div
          className={classNames(
            css.simDetailsText,
            mode === "light" ? css.light : css.dark,
            !isDesktop ? css.compact : ""
          )}
        >
          <PuxText>
            Sist brukt:{" "}
            {!!lastUsed ? (
              i18n.format(lastUsed, DateFormat.Date)
            ) : (
              <span style={{ opacity: 0.66 }}>Ingen bruk</span>
            )}
          </PuxText>
        </div>
      )}

      <div
        className={classNames(
          css.simDetailsText,
          mode === "light" ? css.light : css.dark,
          !isDesktop ? css.compactMiddle : ""
        )}
      >
        <PuxText style={usage >= 1000 ? { marginRight: "-5px" } : {}}>
          Databruk:{" "}
          {usage && usage > 0 ? (
            usage
          ) : (
            <span style={{ opacity: 0.66 }}>0</span>
          )}{" "}
          GB{" "}
        </PuxText>
        <InfoBox
          size={20}
          noSpaceAround
          message={
            "Databruk per SIM-kort for inneværende måned kan være forsinket. Sjekk forsiden for oppdatert totalforbruk i sanntid."
          }
        />
      </div>
      <div
        className={classNames(
          css.simDetailsText,
          mode === "light" ? css.light : css.dark,
          !isDesktop ? css.compact : ""
        )}
      >
        <PuxText>
          Aktivert:
          {!isDesktop ? <br /> : " "}
          {i18n.format(activationDate, DateFormat.Date)}
        </PuxText>
      </div>
      {!!deviceName && (
        <div
          className={classNames(
            css.simDetailsText,
            mode === "light" ? css.light : css.dark
          )}
        >
          <PuxText>Enhet: </PuxText>
          <PuxText>{deviceName}</PuxText>
        </div>
      )}
      {showPrice && price !== undefined && (
        <div
          className={classNames(
            css.simDetailsText,
            mode === "light" ? css.light : css.dark
          )}
        >
          <PuxText>Pris: </PuxText>
          <Price value={price} suffix={["perMonth"]} />
        </div>
      )}
    </div>
  )
}
